// Angular
import { Component, Input, OnInit } from '@angular/core';

// Libraries

// Afidium
import { IApiPagingOutput } from 'libraries/service/resources/IApiPagingOutput';
import { ISearchStatus } from "app_sasha/shared/interfaces/ISearchStatus";

import { Yii } from "libraries/interfaces/Yii";
import { IGetBookingsCommonResponse } from 'libraries/service/resources/booking/interfaces/IGetBookings';

export enum ProcessingResultsContainerContexts {
    HOME = 'home',
    SEARCH_RESULT = 'search-result',
}

@Component({
    selector: 'processing-results-container',
    template: `
        <card>
            <div class="card-header-content">
                <h1 *ngIf="labels.header">{{ labels?.header }}</h1>
            </div>
            <div class="card-body-content">
                <loader *ngIf="searchStatus.isLoading" [message]="labels.Loading"></loader>
                <notification *ngIf="searchStatus.isError" type="error">
                    <strong>{{ labels.Error }}</strong> {{searchStatus.errorMessage}}
                </notification>
                <notification *ngIf="searchStatus.isWarning" type="warning">
                    {{searchStatus.errorMessage}}
                </notification>
                <processing-list [processings]="processings"
                                 [recordset]="recordset" [context]="context"></processing-list>
                <ng-content select=".processing-results-footer"></ng-content>
            </div>
        </card>
    `,
    styles: [`
        card ::ng-deep header.header:not(.booking-list-header){
            min-height: 61px;
            line-height: 40px;
        }

        notification{
            margin: 12px;
            display: block;
        }
    `]
})

export class ProcessingResultContainerComponent implements OnInit {

    //////////////////////////////////// COMPONENT VARIABLES ////////////////////////////////////

    @Input()
    public context: ProcessingResultsContainerContexts;

    @Input()
    public processings: IGetBookingsCommonResponse[];

    @Input()
    public recordset: IApiPagingOutput;

    @Input()
    public searchStatus: ISearchStatus = {
        isLoading: false,
        isError: false,
        isWarning: false,
        errorMessage: null,
    };

    public labels: { [key: string]: string } = {
        header: '',
        Loading: Yii.t('wui-sasha-js', 'Recherche des traitements en cours'),
        Error: Yii.t('wui-sasha-js', 'Le chargement des traitements a échoué'),
    };

    //////////////////////////////////// COMPONENT LIFECYCLE HOOKS ////////////////////////////////////

    public ngOnInit() {
        this.labels.header = this.getHeaderLabel();
    }

    //////////////////////////////////// COMPONET METHODS ///////////////////////////////////

    public getHeaderLabel(): string {
        switch (this.context) {
            case ProcessingResultsContainerContexts.HOME:
                return Yii.t('wui-sasha-js', 'Derniers traitements');
            case ProcessingResultsContainerContexts.SEARCH_RESULT:
                return Yii.t('wui-sasha-js', 'Résultats de la recherche');
        }
    }
}